export const options = { showStepsCounter: false }
export const config = [
  {
    size: 'medium',
    scroll: { lock: true },
    delay: 1000,
    className: 'app-guide-text',
    overlay: {
      pointerEvents: 'all',
      opacity: 0.8
    },
    analytics: [
      'LigaPass_Hint_View',
      { hint_name: 'Добро пожаловать в L1GA Pass' }
    ],
    title: 'Добро пожаловать в L1GA Pass!',
    text: 'Это интерактивный ивент, где ты можешь зарабатывать игровые баллы и тратить их на крутые призы, например: ножи, арканы и фрибеты. Сейчас мы быстро объясним тебе, как все устроено!',
    buttons: [
      {
        text: 'Ок',
        theme: 'accent'
      },
      {
        text: 'Пропустить знакомство',
        emit: 'skip'
      }
    ]
  },
  {
    size: 'medium',
    element: '[data-menu-id="tasks"]',
    scroll: { lock: true },
    className: 'app-guide-tasks',
    overlay: {
      pointerEvents: 'all',
      opacity: 0.8
    },
    analytics: [
      'LigaPass_Hint_View',
      {
        hint_name: 'Таски'
      }
    ],
    offset: { top: 20 },
    text: 'На этой странице ты видишь список всех доступных для выполнения заданий. Выполняй задания — получай LIGA коины, все просто.',
    buttons: [
      { text: 'Ок', theme: 'accent' },
      { text: 'Пропустить', emit: 'skip' }
    ]
  },
  {
    size: 'medium',
    element: '[data-menu-id="battlepass"]',
    className: 'app-guide-battlepass',
    analytics: [
      'LigaPass_Hint_View',
      {
        hint_name: 'Battlepass'
      }
    ],
    overlay: {
      pointerEvents: 'all',
      opacity: 0.8
    },
    offset: { top: 20 },
    text: 'Выполняй задания, получай опыт и апай уровни! За каждый пройденный уровень ты получишь награду: от коинов до фрибетов. Сможешь пройти весь Season Pass?',
    buttons: [
      { text: 'Ок', theme: 'accent' },
      { text: 'Пропустить', emit: 'skip' }
    ]
  },
  {
    size: 'medium',
    element: '[data-menu-id="shop"]',
    className: 'app-guide-shop',
    scroll: { lock: true },
    analytics: [
      'LigaPass_Hint_View',
      {
        hint_name: 'Магазин'
      }
    ],
    overlay: {
      pointerEvents: 'all',
      opacity: 0.8
    },
    offset: { top: 20 },
    text: 'Здесь ты можешь обменять свои коины на призы. Обрати внимание — перед первой покупкой тебе необходимо выполнить особое задание на доступ к магазину. Заглядывай сюда почаще, магазин регулярно пополняется новыми товарами.',
    buttons: [
      { text: 'Ок', theme: 'accent' },
      { text: 'Пропустить', emit: 'skip' }
    ]
  },
  {
    size: 'medium',
    element: '#sidebar-account-coins',
    className: 'app-guide-coins',
    analytics: [
      'LigaPass_Hint_View',
      {
        hint_name: 'Коины'
      }
    ],
    overlay: {
      pointerEvents: 'all',
      opacity: 0.8,
      padding: 6
    },
    offset: { top: 20 },
    text: 'Здесь отображается твой баланс. Редкая валюта, которая выдается за выполнение особых заданий.',
    buttons: [
      { text: 'Ок', theme: 'accent' },
      { text: 'Пропустить', emit: 'skip' }
    ]
  },
  {
    size: 'medium',
    element: '[data-menu-id="profile"]',
    className: 'app-guide-menu-profile',
    analytics: [
      'LigaPass_Hint_View',
      {
        hint_name: 'Профиль'
      }
    ],
    overlay: {
      pointerEvents: 'all',
      opacity: 0.8
    },
    offset: { top: 20 },
    text: 'Твой профиль. Полностью настрой свой аккаунт — тогда ты получишь доступ к игровым заданиям и будешь получать призы из магазина без задержек. Не забудь подключить уведомления в Telegram, чтобы быть в курсе всех событий ивента!',
    buttons: [
      { text: 'Ок', theme: 'accent' },
      { text: 'Пропустить', emit: 'skip' }
    ]
  },
  {
    size: 'medium',
    element: '[data-menu-id="FAQ"]',
    position: 'top',
    offset: { bottom: 20 },
    analytics: [
      'LigaPass_Hint_View',
      {
        hint_name: 'FAQ'
      }
    ],
    className: 'app-guide-support',
    overlay: {
      pointerEvents: 'all',
      opacity: 0.8,
      padding: 6
    },
    text: 'Обязательно прочитай FAQ — мы спрятали там несколько кодов. Если столкнешься с проблемами, то обращайся в саппорт.\n\nУдачи на ивенте!',
    buttons: [{ text: 'Завершить', theme: 'accent' }]
  }
]
